/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";

import type { RouteObject } from "react-router-dom";
import SiteScheduleAnalysis from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/SiteScheduleAnalysis.tsx";

const HumanResourcesPage = lazy(() => import("./HumanResourcesPage.tsx"));

const Schedules = lazy(
  () => import("./time-management/schedules/Schedules.tsx"),
);

const SiteScheduleDateRange = lazy(
  () => import("./time-management/schedules/SiteScheduleDateRange.tsx"),
);

const SignatureMonitoring = lazy(
  () =>
    import("./time-management/signature/monitoring/SignatureMonitoring.tsx"),
);

const SignatureMonitoringContainer = lazy(
  () =>
    import(
      "./time-management/signature/monitoring/SignatureMonitoringContainer.tsx"
    ),
);

export const humanResourcesRoutes: RouteObject[] = [
  {
    path: "/hr",
    element: <HumanResourcesPage />,
    children: [
      {
        // Time management -----------------------------------------------------
        path: "time/schedules/domain?/:domainId?/site?/:siteId?",
        element: <Schedules />,
        children: [
          {
            path: ":range?/:date?",
            element: <SiteScheduleDateRange />,
          },
          {
            path: "analysis/:range/:date",
            element: <SiteScheduleAnalysis />,
          },
        ],
      },
      {
        path: "signature/monitoring",
        element: <SignatureMonitoring />,

        children: [
          {
            path: "domain?/:domainId?",
            element: <SignatureMonitoringContainer />,
          },
        ],
      },
    ],
  },
];
